const find = require('lodash/find');
const reduce = require('lodash/reduce');
const isEmpty = require('lodash/isEmpty');
const get = require('lodash/get');
const some = require('lodash/some');
const pick = require('lodash/pick');

const logger = require('../../logger');

const getAvailableProducts = products =>
  (products || []).filter(product => product.variants && product.variants.length > 0);

const getAvailableProductIds = products =>
  getAvailableProducts(products).map(product => product.id);

const getAvailableProductLanguages = product => {
  if (!product) {
    return [];
  }

  return product.variants
    .map(variant => variant.options.locale)
    .filter((value, index, array) => array.indexOf(value) === index);
};

const findProductById = (products, productId) => {
  return find(products, product => product.id === productId) || null;
};

const findProductLocaleVariants = (variants, options) => {
  if (!variants || isEmpty(variants) || !options || isEmpty(options)) {
    return [];
  }
  const optionKeys = Object.keys(pick(options, ['locale']));
  return variants.reduce((result, variant) => {
    if (!some(result, value => value === variant.formatId)) {
      const optionsValid = optionKeys.every(optionKey => {
        if (variant.options[optionKey]) {
          return variant.options[optionKey] === options[optionKey];
        }
        return true;
      });

      if (optionsValid) {
        result.push(variant);
      }
    }
    return result;
  }, []);
};

const findLowestVariantPrice = (variants, options) => {
  if (options && !isEmpty(options)) {
    const localeVariants = findProductLocaleVariants(variants, options);
    variants = isEmpty(localeVariants) ? variants : localeVariants;
  }
  const variant = variants.reduce(
    (prev, curr) => {
      const currIsCheaper = prev.price.amount > curr.price.amount;
      const prevIsCheaper = prev.price.amount < curr.price.amount;
      if (!currIsCheaper && !prevIsCheaper) {
        return curr.savings ? curr : prev;
      }
      return prevIsCheaper ? prev : curr;
    },
  );
  let pricing = { price: variant.price };

  if (variant.savings) {
    pricing.savings = variant.savings;
  }

  return pricing;
};

const findLowestProductPrice = (products, productId, options) => {
  const availableProducts = getAvailableProducts(products);
  const product = findProductById(availableProducts, productId);
  return product && findLowestVariantPrice(product.variants, options);
};

const findProductVariant = (variants, options) => {
  if (!variants || isEmpty(variants) || !options || isEmpty(options)) {
    return {};
  }

  options = reduce(options, (result, value, key) => {
    if (key === 'format_identifier' && value.split(':').length === 2) {
      const [ cover, box ] = value.split(':');
      result = {
        ...result,
        cover,
        box
      };
      return result;
    } else if (key === 'format_identifier' && value.split(':').length > 2) {
      const covers = ['softback', 'hardback', 'deluxe', 'pack'];
      const [a, b, size] = value.split(':');
      result = {
        ...result,
        cover: covers.includes(a) ? a : b,
        box: covers.includes(a) ? b : a,
        size
      };
      return result;
    }

    result[key] = value;
    return result;
  }, {});

  const optionKeys = Object.keys(options);
  return variants.find(variant => {
    return optionKeys.every(optionKey => {
      if (variant.options[optionKey]) {
        return variant.options[optionKey] === options[optionKey];
      }
      return true;
    });
  }) || {};
};

const findVariantPrice = (products, productId, options) => {
  const product = findProductById(products, productId);
  if (!product) {
    logger.error({
      msg: `failed to find ${productId}`,
      productId,
      products
    });
    return '';
  }
  const variant = findProductVariant(product.variants, options);
  const lowestPricing = findLowestVariantPrice(product.variants);
  return get(variant, 'price.formatted', null) || get(lowestPricing, 'price.formatted', '');
};

module.exports = {
  getAvailableProducts,
  getAvailableProductIds,
  findProductById,
  findLowestVariantPrice,
  findLowestProductPrice,
  findVariantPrice,
  getAvailableProductLanguages,
  findProductLocaleVariants,
  findProductVariant,
};



// WEBPACK FOOTER //
// ./src/common/utils/product.js